var PROJ = (typeof PROJ === 'object') ? PROJ : {};
PROJ.pdp = {
    VAR: {},
    init: function () {
        var _this = this;
        // This can be ajax loaded content, so use event delegation for dynamically added forms
        document.body.addEventListener('submit', function (e) {
            var form = e.target;
            if (
                form.matches &&
                form.matches('form[action="/cart/add"].fs-product-form')
            ) {
                e.preventDefault();
                var addToCartBtn = form.querySelector('.addtocart');
                if (addToCartBtn) {
                    addToCartBtn.classList.add('disabled');
                    addToCartBtn.disabled = true;
                }

                var formData = new FormData(form);

                fetch('/cart/add.js', {
                    method: 'POST',
                    body: new URLSearchParams(formData),
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    }
                })
                    .then(response => response.json())
                    .then(data => {
                        if (typeof PROJ !== 'undefined' && PROJ.ajaxcart && typeof PROJ.ajaxcart.updateCart === 'function') {
                            PROJ.ajaxcart.updateCart();
                        }
                        if (addToCartBtn) {
                            addToCartBtn.classList.remove('disabled');
                            addToCartBtn.disabled = false;
                        }
                    })
                    .catch(error => {
                        if (typeof PROJ !== 'undefined' && PROJ.ajaxcart && typeof PROJ.ajaxcart.updateCart === 'function') {
                            PROJ.ajaxcart.updateCart();
                        }
                        console.error('Error adding item to cart:', error);
                    });
            }
        });

        // Handle option swatch/item clicks for custom product form

        ['click', 'touchstart'].forEach(eventType => {
            document.body.addEventListener(eventType, function (e) {

                let target = e.target;

                // for product option clicks
                if (target.closest('[data-o-value]')) {
                    e.preventDefault();
                    let clicked = target.closest('[data-o-value]');

                    var clickedValue = clicked.getAttribute('data-o-value');
                    var parentOption = clicked.closest('[data-oselected-value]');
                    if (!parentOption) return;

                    // Update parent [data-oselected-value] attribute
                    parentOption.setAttribute('data-oselected-value', clickedValue);

                    // Remove 'active' from siblings, add to clicked
                    var siblings = clicked.parentElement.querySelectorAll('[data-o-value]');
                    siblings.forEach(function (sibling) {
                        sibling.classList.remove('active');
                    });
                    clicked.classList.add('active');

                    // Update .zop-title > span text under this option using title attribute
                    var zopTitle = parentOption.querySelector('.zop-title');
                    if (zopTitle) {
                        var span = zopTitle.querySelector('span');
                        if (span) {
                            // Replace text with clicked item's title attribute
                            var newTitle = clicked.getAttribute('title') || '';
                            span.textContent = newTitle;
                        }
                    }

                    // Call updateForm at the end
                    if (typeof PROJ !== 'undefined' && PROJ.pdp && typeof PROJ.pdp.updateForm === 'function') {
                        PROJ.pdp.updateForm(parentOption.closest('form'));
                    }

                    // Scroll to matching data-thumb-var element in thumbnail gallery and update main gallery
                    // Find the product form's section to scope the search
                    var productForm = parentOption.closest('form');
                    var productSection = productForm ? productForm.closest('[id^="shopify-section-"]') : null;
                    var searchScope = productSection || document;

                    var matchingThumb = searchScope.querySelector('[data-thumb-var="' + clickedValue + '"]');
                    if (matchingThumb) {
                        var thumbGallery = matchingThumb.closest('.fs-thumb-gal');
                        if (thumbGallery) {
                            // Get all thumbnail cells
                            var thumbCells = thumbGallery.querySelectorAll('.fs-thu');
                            var thumbIndex = Array.from(thumbCells).indexOf(matchingThumb);

                            if (thumbIndex !== -1 && typeof Flickity !== 'undefined') {
                                // Get Flickity instance for thumbnail gallery
                                var flkty = Flickity.data(thumbGallery);
                                if (flkty) {
                                    flkty.select(thumbIndex);

                                    // Also select the corresponding cell in main gallery
                                    var mainGallery = searchScope.querySelector('.fs-main-gal');
                                    if (mainGallery) {
                                        var mainFlickity = Flickity.data(mainGallery);
                                        if (mainFlickity) {
                                            mainFlickity.select(thumbIndex);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            });
        });

    },
    updateForm: function (thisform) {
        // INSERT_YOUR_CODE
        if (!thisform) return;

        // Get all elements with data-oselected-value inside the form
        var selectedOptionEls = thisform.querySelectorAll('[data-oselected-value]');
        var combinedValue = '';
        selectedOptionEls.forEach(function (el) {
            var val = el && el.getAttribute && el.getAttribute('data-oselected-value');
            if (val) {
                combinedValue += val;
            }
        });

        // Find the .pr-variants select box inside the form
        var selectBox = thisform.querySelector('.pr-variants');
        var addToCartBtn = thisform.querySelector('.addtocart');
        if (selectBox) {
            // Find the option whose data-options matches the combined value

            var prEl = addToCartBtn.querySelector('.pr');
            if (prEl) {
                prEl.innerHTML = "";
            }

            var matchedOption = selectBox.querySelector('option[data-options="' + combinedValue + '"]');
            if (matchedOption) {
                selectBox.value = matchedOption.value;
                // Optionally, trigger change event if needed
                var event = new Event('change', {bubbles: true});
                selectBox.dispatchEvent(event);

                // Get the product URL (without query string or hash)
                var productUrl = window.location.origin + window.location.pathname;
                // Set the URL to productUrl?variant=matchedOption.value
                var newUrl = productUrl + '?variant=' + matchedOption.value;
                window.history.replaceState({}, '', newUrl);

                // Check data-available attribute and update .addtocart button
                if (addToCartBtn) {
                    var isAvailable = matchedOption.getAttribute('data-available');
                    if (isAvailable === 'false') {
                        addToCartBtn.classList.add('deactive');
                        addToCartBtn.setAttribute('disabled', 'disabled');
                    } else {
                        addToCartBtn.classList.remove('deactive');
                        addToCartBtn.removeAttribute('disabled');
                    }

                    // Get data-var-price and replace text inside .pr in the addToCartBtn
                    var varPrice = matchedOption.getAttribute('data-var-price');
                    if (varPrice) {
                        var prEl = addToCartBtn.querySelector('.pr');
                        if (prEl) {
                            prEl.innerHTML = "| " + varPrice;
                        }
                    }
                }
            } else {
                // If no matching option, disable add to cart
                if (addToCartBtn) {
                    addToCartBtn.classList.add('deactive');
                    addToCartBtn.setAttribute('disabled', 'disabled');
                }
            }
        } else {
            // If selectBox is not found, disable add to cart
            if (addToCartBtn) {
                addToCartBtn.classList.add('deactive');
                addToCartBtn.setAttribute('disabled', 'disabled');
            }
        }

    },
    updateCart: function () {
        location.reload();
    }
};

document.addEventListener('DOMContentLoaded', function () {
    PROJ.pdp.init();
    // PROJ.ajaxcart.init();

    // fetch(location.pathname+'?section_id=zpro-product-quotes-all')
    //     .then(r=>r.text())
    //     .then(h=>{
    //         let d=document.createElement('div');
    //         d.innerHTML=h;
    //         document.body.appendChild(d.firstElementChild);
    //     });

    // loadProductSection('white-1-4-fold-cocktail-100-organic-cotton-8-x-8-folded-4-x-4-30-units');

});

//quote section load
function loadProductSection(productHandle) {
    document.querySelector('body').classList.add('fs-popup');
    document.querySelector('html').classList.add('fs-popup');

    fetch(`/products/${productHandle}?section_id=zpro-product-quotes-all`)
        .then(r=>r.text())
        .then(h=>{
            let d=document.createElement('div');
            d.innerHTML=h;
            document.body.appendChild(d.firstElementChild);

        // INSERT_YOUR_CODE
        setTimeout(function() {
            var fixpopQuotes = document.querySelector('.fixpop-quotes');
            if (fixpopQuotes) {
                fixpopQuotes.classList.add('active');
            }
        }, 1000);

        });

}



document.addEventListener('click', function (e) {
    let target = e.target;

    if (target.classList.contains('clossquotes')) {
        e.preventDefault();
        document.querySelector('body').classList.remove('fs-popup');
        document.querySelector('html').classList.remove('fs-popup');
    }

    if (target.hasAttribute('data-quotes')) {
        document.querySelector('body').classList.add('fs-popup');
        document.querySelector('html').classList.add('fs-popup');

        var productHandle = target.getAttribute('data-quotes');

    // INSERT_YOUR_CODE

    if (productHandle && productHandle.trim() !== "") {
        var chtml = document.querySelector('.fixpop-quotes .content-pop');
        if (chtml) {
            chtml.innerHTML =  productHandle;
        }
    }

    }

    //Product Card
    //product card change bundle products
    if (target.closest('.jsp-add')) {
        var clicked =  target.closest('.jsp-add');
        e.preventDefault();

        // Get the parent .sp-product-form-container of the clicked element in the current DOM
        var currentFormContainer = clicked.closest('.jspc-add-wrap');
        // Keep the first [data-oselected-value] value from parent .sp-product-form-container
        var keptValue = null;
        if (currentFormContainer) {
            var firstOSelected = currentFormContainer.querySelector('[data-oselected-value]');
            if (firstOSelected) {
                keptValue = firstOSelected.getAttribute('data-oselected-value');
            }
        }

        console.log(currentFormContainer);

        // Get the href link from the clicked .jsp-gitem
        var href = clicked.getAttribute('href');
        if (href) {
            fetch(href)
                .then(function(response) {
                    return response.text();
                })
                .then(function(html) {
                    // Create a temporary DOM to parse the fetched HTML
                    var tempDiv = document.createElement('div');
                    tempDiv.innerHTML = html;
                    // Find the .sp-product-form-container in the fetched HTML
                    var newFormContainer = tempDiv.querySelector('.jspc-add-wrap');
                    if (newFormContainer) {
                        // Replace the content inside the current container with the new one
                        if (currentFormContainer) {
                            currentFormContainer.innerHTML = newFormContainer.innerHTML;

                            // After load, check for first [data-oselected-value] and child [data-o-value] with kept value, and trigger click
                            if (keptValue !== null) {
                                var firstOSelectedNew = currentFormContainer.querySelector('[data-oselected-value]');
                                if (firstOSelectedNew) {
                                    var matchingChild = firstOSelectedNew.querySelector('[data-o-value][data-o-value="' + keptValue + '"]');
                                    if (matchingChild) {
                                        matchingChild.click();
                                    }
                                }
                            }
                        }
                    }

                })
                .catch(function(error) {
                    // Optionally handle errors
                    console.error('Error fetching product form:', error);
                });
        }
    }


// Use Element type for closest and forEach compatibility
if (target && target.closest && target.closest('.v-thumb')) {
    e.preventDefault();
    var clickedThumb = target.closest('.v-thumb');
    if (clickedThumb) {
        // Remove 'active' from all siblings and add to clicked
        var thumbSiblings = clickedThumb.parentElement ? clickedThumb.parentElement.querySelectorAll('.v-thumb') : [];
        thumbSiblings.forEach(function(sibling) {
            sibling.classList.remove('active');
        });
        clickedThumb.classList.add('active');

        // Find parent .jspc-add-wrap > .jspc-add-style and set data-directadd
        var jspcAddWrap = clickedThumb.closest('.jspc-add-wrap');
        if (jspcAddWrap) {
            var jspcAddStyle = jspcAddWrap.querySelector('.jspc-add-style');
            if (jspcAddStyle) {
                var variantId = clickedThumb.getAttribute('data-variant-id');
                if (variantId !== null) {
                    jspcAddStyle.setAttribute('data-directadd', variantId);
                }
            }
        }

        // Get index of the clicked .v-thumb among its siblings
        var vThumbs = Array.prototype.slice.call(clickedThumb.parentElement ? clickedThumb.parentElement.querySelectorAll('.v-thumb') : []);
        var thumbIndex = vThumbs.indexOf(clickedThumb);
        // Get parent .js-card and locate child with [data-shows] attribute to update it
        var jsCard = clickedThumb.closest('.js-card');
        if (jsCard) {
            var dataShowsEl = jsCard.querySelector('[data-shows]');
            dataShowsEl.setAttribute('data-shows', thumbIndex);
        }

        // Get data-car-image and update parent .js-card > img.first-image src and remove srcset
        var carImage = clickedThumb.getAttribute('data-car-image');
        if (carImage) {
            var jsCard = clickedThumb.closest('.js-card');
            if (jsCard) {
                var firstImage = jsCard.querySelector('img.first-image');
                if (firstImage) {
                    firstImage.setAttribute('src', carImage);
                    firstImage.removeAttribute('srcset');
                // If the parent Flickity slider exists, scroll to the first image
                var parentSlider = firstImage.closest('.flickity-enabled');
                if (parentSlider && parentSlider.flickityInstance) {
                    parentSlider.flickityInstance.select(0);
                } else if (parentSlider && typeof Flickity !== 'undefined') {
                    // If Flickity instance is not attached, try to get it via Flickity.data
                    var flkty = Flickity.data(parentSlider);
                    if (flkty) {
                        flkty.select(0);
                    }
                }
                }
            }
        }
    }
}


});


function initJspcImgSliders() {
    // Select all elements with the class 'jspcimg-slider'
    var sliders = document.querySelectorAll('.jspcimg-slider');
    sliders.forEach(function(slider) {
        // Check if Flickity is available and slider not already initialized
        if (typeof Flickity !== 'undefined' && !slider.classList.contains('flickity-enabled')) {
            // Initialize Flickity slider
            new Flickity(slider, {
                cellAlign: 'left',
                contain: true,
                pageDots: true,
                prevNextButtons: true,
                imagesLoaded: true,
                wrapAround: true
            });
            // Remove the class to prevent re-initialization
            slider.classList.remove('jspcimg-slider');
        }
    });
}

// Call the function on page load
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initJspcImgSliders);
} else {
    initJspcImgSliders();
}

